<app-common-environment-banner></app-common-environment-banner>
<mat-sidenav-container
  (backdropClick)="backdropClick()"
  [ngClass]="{ 'has-env-banner': showEnvironmentBanner }"
>
  <mat-sidenav
    *ngIf="!navigationService.opened && deviceService.isLargeScreen()"
    [ngClass]="{ 'opened': navigationService.opened }"
    [@.disabled]="true"
    [mode]="navigationService.opened ? 'over' : 'side'"
    [opened]="true"
    [disableClose]="true"
  >
    <app-sidenav></app-sidenav>
  </mat-sidenav>

  <mat-sidenav
    *ngIf="navigationService.opened"
    [ngClass]="{ 'opened': navigationService.opened }"
    [mode]="navigationService.opened ? 'over' : 'side'"
    [(opened)]="navigationService.opened"
  >
    <app-sidenav></app-sidenav>
  </mat-sidenav>

  <mat-sidenav-content [ngClass]="{ 'full-width': deviceService.isLargeScreen() }">
    <div
      fxLayout="column"
      fxFlexFill
      class="root-container"
      style.background-image="url('{{ background }}')"
    >
      <app-header></app-header>
      <div class="content-container-outer">
        <div class="content-container-inner">
          <app-common-breadcrumbs
            [breadcrumbs]="breadcrumbs"
            [homeIcon]="true"
          ></app-common-breadcrumbs>
          <app-common-message
            *ngFor="let bannerMessage of bannerMessages; trackBy: trackByMessageId"
            [message]="bannerMessage"
          ></app-common-message>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-message></app-message>
<app-common-chatbot *ngIf="showChatbot"></app-common-chatbot>
